<template>
    <div class="contributors-page-card column" v-if="contributorsPage">
        <div class="header row">
            <span >{{$t('contributorsPageBanner')}}</span>
            <span class="close-icon" @click="goBack()">&times;</span>
        </div>
        <div class="content column">
            <span v-html="contributorsPage.content"></span>
            <span v-if="!contributorsPage.content" class="centered">{{$t('noContentToDisplayMessage')}}</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ContributorsPage',
  methods:{
      goBack(){
          if(this.$store.state.isPreviewModeActive)
            return
          this.$router.go(-1)
      }
  },
  created(){
    this.$store.dispatch('loadContributorsPage', this.$store.state.isPreviewModeActive)
  },
  computed:{
    contributorsPage(){
        return this.$store.state.contributorsPage
    }
  }
}
</script>

<style lang="less">
.contributors-page-card{
    margin-top: 104px;
    height: 100vh;

    .header{
        width: 100%;
        background-color: #EAEBFF;
        min-height: 66px;
        span{
            color: #0A1554;
            margin-left: 175px;
            margin-left: auto;
            align-self: center;
            font-family: 'Roboto', sans-serif;
            font-size: 12px;
            font-weight: bold;
            letter-spacing: 2px;
            line-height: 16px;
            white-space: normal;
        }

        .close-icon{
            margin-right: 45px;
            margin-left: auto;
            justify-self: flex-end;
            align-self: center;
            font-size: 2em;
            font-weight: 400;
            color: rgba(10, 21, 84, 0.6);
            &:hover{
                cursor: pointer;
            }
        }
    }

    .content{
        width: 1024px;
        margin: 19px auto;
        .column{
            position: relative;
        }

        p, span, strong em{
            color: #0A1554;
            font-family: 'Roboto', sans-serif;
            font-size: 16px;
            letter-spacing: 0.5px;
            line-height: 28px;
            white-space: normal;
            overflow: initial;
        }

        strong{
            text-decoration: none;
        }
        ul:nth-child(4){
            margin-left: 40px;
        }

        ul, ol{
            padding-left: 40px;
            li{
                list-style-type: disc;
                list-style: initial;
            }
        }
        
        ol{
            li{
                list-style-type:upper-alpha;
            }
        }

        li{
            max-width: 824px;
        }
        span{
            p{
                padding: 0;
                margin: 0;
            }
        }
        
    }
}

</style>